import type { IconSvgObject } from './types';

const PyramidStructure01Icon: IconSvgObject = [
  ["path", { d: "M2 20H22L19.7778 16H4.22222L2 20Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.1111 13L16.4444 10H7.55556L5.88889 13H18.1111Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 2L9.22222 7H14.7778L12 2Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default PyramidStructure01Icon;
